export const learningData=[
    {
        img:"1.jpg",
        date:"05",
        month:"January 2021",
        title:"Java Language",
        name:"by: Paige Turner",
        likes:"15 Hits"
    },
    {
        img:"2.jpg",
        date:"10",
        month:"March 2019",
        title:"Web Development",
        name:"by: Petey Cruiser",
        likes:"34 Hits"
    }
]
export const learningBlogData=[
    {
        img:"3.jpg",
        title:"Web Devlopment.",
        icon:[
              "icon-link","icon-import"  
        ]
    },
    {
        img:"1.jpg",
        title:"Web Design.",
        icon:[
              "icon-link","icon-import"  
        ]
    },
    {
        img:"4.jpg",
        title:"UX Development.",
        icon:[
              "icon-link","icon-import"  
        ]
    },
    {
        img:"2.jpg",
        title:"Spoken English.",
        icon:[
              "icon-link","icon-import"  
        ]
    },
    {
        img:"4.jpg",
        title:"Web Devlopment.",
        icon:[
              "icon-link","icon-import"  
        ]
    },
    {
        img:"3.jpg",
        title:"Advance Design.",
        icon:[
              "icon-link","icon-import"  
        ]
    }
]

export const findCourse =[
    {
        title:"Categories",
        check:[
            {
                type:"checkbox",
                id:"chk-ani",
                name:"Accounting"
            },
            {
                type:"checkbox",
                id:"chk-ani0",
                name:"Design"
            },
            {
                type:"checkbox",
                id:"chk-ani1",
                name:"Development"
            },
            {
                type:"checkbox",
                id:"chk-ani2",
                name:"Management"
            },
            
        ]
    },
    {
        class:"mt-0",
        title:"Duration",
        check:[
            {
                type:"checkbox",
                id:"chk-ani6",
                name:" 0-50 hours"
            },
            {
                type:"checkbox",
                id:"chk-ani7",
                name:"50-100 hours"
            },
            {
                type:"checkbox",
                id:"chk-ani8",
                name:"100+ hours"
            }
        ]
    },
    {
        class:"mt-0",
        title:"Price",
        check:[
            {
                type:"radio",
                id:"edo-ani",
                name:"All Courses",
                names:"rdo-ani"
            },
            {
                type:"radio",
                id:"edo-ani1",
                name:"Paid",
                names:"rdo-ani"
            },
            {
                type:"radio",
                id:"edo-ani2",
                name:"Free",
                names:"rdo-ani"
            }
        ]
    },
    {
        class:"mt-0",
        title:"Status",
        check:[
            {
                type:"checkbox",
                id:"chk-ani3",
                name:"Registration"
            },
            {
                type:"checkbox",
                id:"chk-ani4",
                name:"Progress"
            },
            {
                type:"checkbox",
                id:"chk-ani5",
                name:"Completed"
            }
        ]
    }
]